// Maps onboarding objectives to recommended Dashboard opportunities (demo).
export const OBJECTIVE_RECOMMENDATIONS = {
  "Increase revenue": [
    { title: "Optimiser le pricing sur les séjours 5–7 nuits", category: "Pricing", potential: "+120 K€" },
    { title: "Lancer des packages premium à forte marge", category: "Revenue", potential: "+95 K€" },
  ],
  "Develop low season": [
    { title: "Offres ciblées avril–juin pour lisser l'occupation", category: "Saisonnalité", potential: "+70 K€" },
    { title: "Campagne basse saison sur marchés long-courrier", category: "Marché", potential: "+60 K€" },
  ],
  "Find new source markets": [
    { title: "Activer le marché émergent indien (+31 %)", category: "Marché", potential: "+140 K€" },
    { title: "Prospection Moyen-Orient à fort panier moyen", category: "Marché", potential: "+110 K€" },
  ],
  "Improve occupancy": [
    { title: "Yield management sur les nuitées creuses", category: "Occupation", potential: "+80 K€" },
    { title: "Partenariat aérien pour flux additionnels", category: "Partenaire", potential: "+65 K€" },
  ],
  "Develop distribution": [
    { title: "Onboarder 3 DMC premium compatibles", category: "Distribution", potential: "+130 K€" },
    { title: "Élargir la présence OTA sur marchés clés", category: "Distribution", potential: "+55 K€" },
  ],
  "Activate partners": [
    { title: "Réactiver 14 partenaires UK dormants", category: "Activation", potential: "+62 K€" },
    { title: "Co-marketing avec un transporteur régional", category: "Partenaire", potential: "+48 K€" },
  ],
  "Improve visitor dispersion": [
    { title: "Promouvoir les zones secondaires hors pics", category: "Dispersion", potential: "+40 K€" },
    { title: "Itinéraires multi-sites pour étaler les flux", category: "Dispersion", potential: "+35 K€" },
  ],
  "Measure performance": [
    { title: "Tableau d'attribution ROI par canal", category: "Performance", potential: "Insight" },
    { title: "Benchmark vs. destinations concurrentes", category: "Performance", potential: "Insight" },
  ],
};

export function recommendationsFor(objectives = [], limit = 5) {
  const out = [];
  for (const obj of objectives) {
    const recs = OBJECTIVE_RECOMMENDATIONS[obj] || [];
    for (const r of recs) out.push({ ...r, objective: obj });
  }
  return out.slice(0, limit);
}
